<div [style.background-color]="color" [class]="{'color-primary': primary, 'color-inactive': !primary || profile.imageUrl, 'big': big}" [title]="title"
     [class.tabs-profile-icon]="isOnTabs" class="profile-wrapper no-select no-border relative">
  <div *ngIf="!profile.imageUrl" class="center-by-relative-parent initials">
    {{ firstName.charAt(0) + lastName.charAt(0) }}
  </div>
  <app-image class="profile-photo" rounded  *ngIf="profile.imageUrl" [src]="profile.imageUrl" [alt]="profile.id" />
</div>
